export function getMyHome(permissions) {
  if (permissions?.find((p) => p.prefix === 'list-user-people-group')) {
    return '/upgs';
  }
  if (permissions?.find((p) => p.prefix === 'list-user-training-course')) {
    return '/training/courses';
  }
  return '/partner';
}
